
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ArrowLeft, User, Mail, Phone, MapPin, Camera } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ResponsiveNavigation from '@/components/ResponsiveNavigation';

const Profile = () => {
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState<string | null>(null);

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setProfileImage(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 font-lato">
      <ResponsiveNavigation />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Back Button and Title */}
        <div className="flex items-center mb-6">
          <Button 
            variant="ghost" 
            onClick={() => navigate(-1)}
            className="mr-4 text-vitl-navy hover:text-vitl-green font-lato"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Button>
          <h1 className="text-3xl font-syne font-medium text-vitl-navy">Profile</h1>
        </div>

       

        {/* Profile Information */}
        <Card className="border-l-4 border-l-emerald-500 shadow-sm hover:shadow-md transition-all duration-200 shadow-emerald-100/50 mb-6">
          <CardHeader>
            <CardTitle className="text-xl font-syne font-medium text-vitl-navy">Personal Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-1">
                <Label htmlFor="first-name" className="text-sm font-lato font-medium text-vitl-navy">
                  First Name
                </Label>
                <Input
                  id="first-name"
                  placeholder="Enter your first name"
                  defaultValue="John"
                  className="h-12 bg-gray-50 border-gray-200 font-lato focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus:border-emerald-400 focus:outline-none"
                />
              </div>

              <div className="space-y-1">
                <Label htmlFor="last-name" className="text-sm font-lato font-medium text-vitl-navy">
                  Last Name
                </Label>
                <Input
                  id="last-name"
                  placeholder="Enter your last name"
                  defaultValue="Doe"
                  className="h-12 bg-gray-50 border-gray-200 font-lato focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus:border-emerald-400 focus:outline-none"
                />
              </div>

              <div className="space-y-1">
                <Label htmlFor="email" className="text-sm font-lato font-medium text-vitl-navy">
                  Email Address
                </Label>
                <div className="relative">
                  <Mail className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-vitl-dark/50" />
                  <Input
                    id="email"
                    type="email"
                    placeholder="Enter your email"
                    defaultValue="john.doe@example.com"
                    className="pl-10 h-12 bg-gray-50 border-gray-200 font-lato focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus:border-emerald-400 focus:outline-none"
                  />
                </div>
              </div>

              <div className="space-y-1">
                <Label htmlFor="phone" className="text-sm font-lato font-medium text-vitl-navy">
                  Phone Number
                </Label>
                <div className="relative">
                  <Phone className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-vitl-dark/50" />
                  <Input
                    id="phone"
                    type="tel"
                    placeholder="Enter your phone number"
                    defaultValue="+1 (555) 123-4567"
                    className="pl-10 h-12 bg-gray-50 border-gray-200 font-lato focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus:border-emerald-400 focus:outline-none"
                  />
                </div>
              </div>

              
            </div>
          </CardContent>
        </Card>

       

        {/* Save Button */}
        <div className="flex justify-end">
          <Button 
            className="bg-vitl-green hover:bg-vitl-green/90 text-white font-lato font-medium px-8 py-3 h-auto"
          >
            Save Changes
          </Button>
        </div>
      </main>
    </div>
  );
};

export default Profile;
